// Quick Filter Configurations for different modules

// Common date range options
export const dateRangeOptions = [
  { key: 'Today', label: 'Today' },
  { key: 'Yesterday', label: 'Yesterday' },
  { key: 'ThisWeek', label: 'This Week' },
  { key: 'LastWeek', label: 'Last Week' },
  { key: 'ThisMonth', label: 'This Month' },
  { key: 'LastMonth', label: 'Last Month' }
];

export const dealsQuickFilterConfig = {
  search: {
    placeholder: 'Search name or description',
    field: ['title', 'description'] // Search in multiple fields
  },
  dropdowns: [
    {
      key: 'pipeline',
      placeholder: 'Select Pipeline',
      field: 'pipelineId',
      options: 'dynamic', // Will fetch from Redux store
      icon: true
    }
  ],
  checkboxFilters: [
    {
      key: 'owner',
      label: 'Deal owner',
      field: 'ownerId',
      options: 'dynamic' // Will fetch users dynamically
    },
    {
      key: 'tags',
      label: 'All Tags',
      field: 'tags',
      options: 'dynamic' // Will fetch tags dynamically
    }
  ],
  dateFilters: [
    { key: 'createdAt', label: 'Create date', field: 'createdAt' },
    { key: 'updatedAt', label: 'Activity date', field: 'updatedAt' },
    { key: 'closeDate', label: 'Close date', field: 'closeDate' }
  ],
  moreFilters: {
    // Properties that can be added as quick filters
    amount: {
      label: 'Amount',
      type: 'number',
      field: 'amount',
      options: [
        { value: '0-100', label: '0 - 100' },
        { value: '100-500', label: '100 - 500' },
        { value: '500-1000', label: '500 - 1,000' },
        { value: '1000-5000', label: '1,000 - 5,000' },
        { value: '5000+', label: '5,000+' }
      ]
    },
    stage: { label: 'Deal Stage', type: 'select', field: 'stage', options: 'dynamic' },
    probability: {
      label: 'Probability',
      type: 'number',
      field: 'probability',
      options: [
        { value: '0-25', label: '0% - 25%' },
        { value: '25-50', label: '25% - 50%' },
        { value: '50-75', label: '50% - 75%' },
        { value: '75-100', label: '75% - 100%' }
      ]
    },
    dealType: {
      label: 'Deal Type',
      type: 'select',
      field: 'dealType',
      options: [
        { value: 'new_business', label: 'New Business' },
        { value: 'existing_business', label: 'Existing Business' },
        { value: 'renewal', label: 'Renewal' }
      ]
    },
    source: {
      label: 'Source',
      type: 'select',
      field: 'source',
      options: [
        { value: 'website', label: 'Website' },
        { value: 'referral', label: 'Referral' },
        { value: 'cold_call', label: 'Cold Call' },
        { value: 'email', label: 'Email' },
        { value: 'social_media', label: 'Social Media' }
      ]
    }
  }
};

export const contactsQuickFilterConfig = {
  search: {
    placeholder: 'Search name, email or phone',
    field: ['firstName', 'lastName', 'email', 'phone']
  },
  dropdowns: [
    {
      key: 'status',
      placeholder: 'Select Status',
      field: 'status',
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' },
        { value: 'lead', label: 'Lead' },
        { value: 'customer', label: 'Customer' }
      ]
    }
  ],
  checkboxFilters: [
    {
      key: 'owner',
      label: 'Contact owner',
      field: 'ownerId',
      options: 'dynamic'
    },
    {
      key: 'tags',
      label: 'All Tags',
      field: 'tags',
      options: 'dynamic'
    },
    {
      key: 'source',
      label: 'Contact source',
      field: 'source',
      options: [
        { value: 'apollo', label: 'Apollo' },
        { value: 'contactOut', label: 'ContactOut' },
        { value: 'contactMagic', label: 'ContactMagic' },
        { value: 'manual', label: 'Manual Entry' },
        { value: 'import', label: 'Import' }
      ]
    }
  ],
  dateFilters: [
    { key: 'createdAt', label: 'Create date', field: 'createdAt' },
    { key: 'updatedAt', label: 'Last activity', field: 'updatedAt' }
  ],
  moreFilters: {
    company: { label: 'Company', type: 'text', field: 'company' },
    title: { label: 'Job Title', type: 'text', field: 'title' },
    city: { label: 'City', type: 'text', field: 'city' },
    state: { label: 'State', type: 'text', field: 'state' },
    country: { label: 'Country', type: 'text', field: 'country' }
  }
};

export const campaignsQuickFilterConfig = {
  search: {
    field: 'name',
    placeholder: 'Search campaign name',
  },
  dropdowns: [
    {
      key: 'status',
      placeholder: 'Select Status',
      field: 'status',
      options: [
        { value: 'draft', label: 'Draft' },
        { value: 'scheduled', label: 'Scheduled' },
        { value: 'sending', label: 'Sending' },
        { value: 'sent', label: 'Sent' },
        { value: 'paused', label: 'Paused' }
      ]
    },
    {
      key: 'type',
      placeholder: 'Campaign Type',
      field: 'type',
      options: [
        { value: 'email', label: 'Email' },
        { value: 'sms', label: 'SMS' },
        { value: 'voicemail', label: 'Voicemail' }
      ]
    }
  ],
  checkboxFilters: [
    { key: 'owner', label: 'Campaign owner', field: 'createdBy', options: 'dynamic' }
  ],
  dateFilters: [
    { key: 'createdAt', label: 'Create date', field: 'createdAt' },
    { key: 'scheduledDate', label: 'Scheduled date', field: 'scheduledDate' },
    { key: 'sentDate', label: 'Sent date', field: 'sentDate' }
  ],
  moreFilters: {
    openRate: { label: 'Open Rate', type: 'number', field: 'statistics.openRate' },
    clickRate: { label: 'Click Rate', type: 'number', field: 'statistics.clickRate' },
    replyRate: { label: 'Reply Rate', type: 'number', field: 'statistics.replyRate' }
  }
};

export const activitiesQuickFilterConfig = {
  search: {
    placeholder: 'Search title or description',
    field: ['title', 'description']
  },
  dropdowns: [
    {
      key: 'type',
      placeholder: 'Activity Type',
      field: 'type',
      options: [
        { value: 'task', label: 'Task' },
        { value: 'call', label: 'Call' },
        { value: 'email', label: 'Email' },
        { value: 'note', label: 'Note' },
        { value: 'meeting', label: 'Meeting' },
        { value: 'sms', label: 'SMS' },
        { value: 'whatsapp', label: 'WhatsApp' }
      ]
    },
    {
      key: 'status',
      placeholder: 'Select Status',
      field: 'status',
      options: [
        { value: 'pending', label: 'Pending' },
        { value: 'in-progress', label: 'In Progress' },
        { value: 'completed', label: 'Completed' },
        { value: 'cancelled', label: 'Cancelled' },
        { value: 'no-answer', label: 'No Answer' },
        { value: 'busy', label: 'Busy' },
        { value: 'failed', label: 'Failed' }
      ]
    },
    {
      key: 'priority',
      placeholder: 'Priority',
      field: 'priority',
      options: [
        { value: 'low', label: 'Low' },
        { value: 'medium', label: 'Medium' },
        { value: 'high', label: 'High' },
        { value: 'urgent', label: 'Urgent' }
      ]
    }
  ],
  checkboxFilters: [
    {
      key: 'assignedTo',
      label: 'Assigned To',
      field: 'assignedTo',
      options: 'dynamic'
    },
    // {
    //   key: 'createdBy',
    //   label: 'Created By',
    //   field: 'createdBy',
    //   options: 'dynamic'
    // },
  ],
  dateFilters: [
    { key: 'createdAt', label: 'Created date', field: 'createdAt' },
    { key: 'dueDate', label: 'Due date', field: 'dueDate' },
    { key: 'completedAt', label: 'Completed date', field: 'completedAt' }
  ],
  moreFilters: {
    taskType: {
      label: 'Task Type',
      type: 'select',
      field: 'taskType',
      options: [
        { value: 'to-do', label: 'To-Do' },
        { value: 'call', label: 'Call' },
        { value: 'email', label: 'Email' }
      ]
    },
    direction: {
      label: 'Call Direction',
      type: 'select',
      field: 'direction',
      options: [
        { value: 'inbound', label: 'Inbound' },
        { value: 'outbound', label: 'Outbound' },
        { value: 'cold_calling', label: 'Cold Calling' }
      ]
    },
    duration: { label: 'Duration (minutes)', type: 'number', field: 'duration' },
    isRecurring: {
      label: 'Recurring',
      type: 'select',
      field: 'isRecurring',
      options: [
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' }
      ]
    },
    queue: { label: 'Queue', type: 'text', field: 'queue' }
  }
};

export const companiesQuickFilterConfig = {
  search: {
    placeholder: 'Search name, domain or industry',
    field: ['name', 'domain', 'industry']
  },
  dropdowns: [
    {
      key: 'status',
      placeholder: 'Select Status',
      field: 'status',
      options: [
        { value: 'prospect', label: 'Prospect' },
        { value: 'customer', label: 'Customer' },
        { value: 'partner', label: 'Partner' },
        { value: 'competitor', label: 'Competitor' },
        { value: 'inactive', label: 'Inactive' }
      ]
    }
  ],
  checkboxFilters: [
    {
      key: 'owner',
      label: 'Company owner',
      field: 'ownerId',
      options: 'dynamic'
    },
    {
      key: 'tags',
      label: 'All Tags',
      field: 'tags',
      options: 'dynamic'
    },
    {
      key: 'industry',
      label: 'Industry',
      field: 'industry',
      options: [
        { value: 'technology', label: 'Technology' },
        { value: 'healthcare', label: 'Healthcare' },
        { value: 'finance', label: 'Finance' },
        { value: 'retail', label: 'Retail' },
        { value: 'manufacturing', label: 'Manufacturing' },
        { value: 'education', label: 'Education' },
        { value: 'consulting', label: 'Consulting' },
        { value: 'real-estate', label: 'Real Estate' },
        { value: 'other', label: 'Other' }
      ]
    }
  ],
  dateFilters: [
    { key: 'createdAt', label: 'Create date', field: 'createdAt' },
    { key: 'updatedAt', label: 'Last activity', field: 'updatedAt' }
  ],
  moreFilters: {
    size: {
      label: 'Company Size',
      type: 'select',
      field: 'size',
      options: [
        { value: '1-10', label: '1-10 employees' },
        { value: '11-50', label: '11-50 employees' },
        { value: '51-200', label: '51-200 employees' },
        { value: '201-500', label: '201-500 employees' },
        { value: '501-1000', label: '501-1000 employees' },
        { value: '1000+', label: '1000+ employees' }
      ]
    },
    revenue: { label: 'Annual Revenue', type: 'number', field: 'revenue' },
    type: {
      label: 'Company Type',
      type: 'select',
      field: 'type',
      options: [
        { value: 'prospect', label: 'Prospect' },
        { value: 'customer', label: 'Customer' },
        { value: 'partner', label: 'Partner' },
        { value: 'vendor', label: 'Vendor' },
        { value: 'other', label: 'Other' }
      ]
    },
    city: { label: 'City', type: 'text', field: 'addressDetails.city' },
    state: { label: 'State', type: 'text', field: 'addressDetails.state' },
    country: { label: 'Country', type: 'text', field: 'addressDetails.country' }
  }
};

export const agentsQuickFilterConfig = {
  search: {
    placeholder: 'Search agent name',
    field: 'name'
  },
  dropdowns: [
    {
      key: 'status',
      placeholder: 'Select Status',
      field: 'status',
      options: [
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' }
      ]
    },
    {
      key: 'type',
      placeholder: 'Agent Type',
      field: 'type',
      options: [
        { value: 'Single Prompt', label: 'Single Prompt' },
        { value: 'Multi Prompt', label: 'Multi Prompt' },
        { value: 'Template', label: 'Template' },
        { value: 'Internal', label: 'Internal' }
      ]
    }
  ],
  checkboxFilters: [
    {
      key: 'tags',
      label: 'All Tags',
      field: 'tags',
      options: 'dynamic'
    }
  ],
  dateFilters: [
    { key: 'createdAt', label: 'Create date', field: 'createdAt' },
    { key: 'updatedAt', label: 'Last updated', field: 'updatedAt' },
    { key: 'statusChangedAt', label: 'Status changed', field: 'statusChangedAt' }
  ],
  moreFilters: {
    phone: { label: 'Phone Number', type: 'text', field: 'phone' },
    modelType: { label: 'Model Type', type: 'text', field: 'modelType' },
    welcomeMessageType: {
      label: 'Welcome Message Type',
      type: 'select',
      field: 'welcomeMessageType',
      options: [
        { value: 'defined', label: 'Defined' },
        { value: 'dynamic', label: 'Dynamic' },
        { value: 'silent', label: 'Silent' }
      ]
    },
    voiceMailDetection: {
      label: 'Voice Mail Detection',
      type: 'select',
      field: 'voiceMailDetection',
      options: [
        { value: 'true', label: 'Enabled' },
        { value: 'false', label: 'Disabled' }
      ]
    },
    enableRecording: {
      label: 'Recording Enabled',
      type: 'select',
      field: 'enableRecording',
      options: [
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' }
      ]
    }
  }
};

// Add more objectType configurations as needed
export const getQuickFilterConfig = (objectType) => {
  switch (objectType) {
    case 'deals':
      return dealsQuickFilterConfig;
    case 'contacts':
      return contactsQuickFilterConfig;
    case 'campaigns':
      return campaignsQuickFilterConfig;
    case 'companies':
      return companiesQuickFilterConfig;
    case 'activities':
      return activitiesQuickFilterConfig;
    case 'agents':
      return agentsQuickFilterConfig;
    default:
      return {};
  }
};